export default "__VITE_ASSET__CwEmbXn3__"